import { cancelarAlert, excluirAlert } from 'app/services/alerts';
import transportadoraApi from 'app/services/api/transportadoraApi';
import { generateActionTypes, generateDefaultActions } from 'app/store/defaultReducer';
import { eventReactGA } from 'app/utils/analyticsUtil';
import { registroTransportadora } from '@core/util/mockTourUtils';

const TRANSPORTADORA = 'Transportadora';

const BASE = '[TRANSPORTADORA]';

const INITIAL_STATE = `${BASE} INITIAL_STATE`;
const MENSAGEM = `${BASE} MENSAGEM`;
const BUSCAR_REGISTROS = `${BASE} BUSCAR_REGISTROS`;
const CADASTRAR_REGISTRO = `${BASE} CADASTRAR_REGISTRO`;
const EDITAR_REGISTRO = `${BASE} EDITAR_REGISTRO`;
const VISUALIZAR_REGISTRO = `${BASE} VISUALIZAR_REGISTRO`;
const REMOVER_REGISTROS = `${BASE} REMOVER_REGISTROS`;
const SELECIONADOS = `${BASE} SELECIONADOS`;
const TIPO_SELECAO = `${BASE} TIPO_SELECAO`;
const CARREGANDO_REGISTROS = `${BASE} CARREGANDO_REGISTROS`;
const CARREGANDO_REGISTRO = `${BASE} CARREGANDO_REGISTRO`;
const FECHAR_MODAL_CADASTRO = `${BASE} FECHAR_MODAL_CADASTRO`;
const FECHAR_MODAL_VISUALIZACAO = `${BASE} FECHAR_MODAL_VISUALIZACAO`;
const SUCESSO = `${BASE} SUCESSO`;
const ERRO = `${BASE} ERRO`;
const REQUEST_PARAMS = `${BASE} REQUEST_PARAMS`;
const SET_FILTRO_AVANCADO = `${BASE}_SET_FILTRO_AVANCADO`;
const FECHAR_MODAL = `${BASE}_FECHAR_MODAL`;

const types = generateActionTypes(BASE);

export const TransportadoraTypes = {
  ...types,
  INITIAL_STATE,
  MENSAGEM,
  BUSCAR_REGISTROS,
  CADASTRAR_REGISTRO,
  REMOVER_REGISTROS,
  EDITAR_REGISTRO,
  VISUALIZAR_REGISTRO,
  SELECIONADOS,
  TIPO_SELECAO,
  CARREGANDO_REGISTROS,
  CARREGANDO_REGISTRO,
  FECHAR_MODAL_CADASTRO,
  FECHAR_MODAL_VISUALIZACAO,
  SUCESSO,
  ERRO,
  REQUEST_PARAMS,
  SET_FILTRO_AVANCADO,
  FECHAR_MODAL,
};

const setFiltroAvancado = (dispatch, filtroAvancado) => {
  dispatch({ type: SET_FILTRO_AVANCADO, payload: filtroAvancado });
};

function fecharModal(dispatch, dirty) {
  const action = {
    type: TransportadoraTypes.FECHAR_MODAL,
  };

  if (dirty) {
    cancelarAlert({
      confirmar: async () => {
        dispatch(action);
      },
    });
  } else {
    dispatch(action);
  }
}

function setInitialState() {
  return {
    type: INITIAL_STATE,
  };
}

function setCurrentPage(page) {
  return {
    type: REQUEST_PARAMS,
    payload: { page },
  };
}
function setPageSize(size) {
  return {
    type: REQUEST_PARAMS,
    payload: { size },
  };
}
function setSorting(sort) {
  return {
    type: REQUEST_PARAMS,
    payload: { sort },
  };
}

function setQuery(q) {
  return {
    type: REQUEST_PARAMS,
    payload: { q },
  };
}

function setSelecionados(payload) {
  return {
    type: SELECIONADOS,
    payload,
  };
}

function setTipoSelecao(payload) {
  return {
    type: TIPO_SELECAO,
    payload,
  };
}

function setCarregandoRegistros(payload) {
  return {
    type: CARREGANDO_REGISTROS,
    payload,
  };
}

function setCarregandoRegistro(payload) {
  return {
    type: CARREGANDO_REGISTRO,
    payload,
  };
}

async function buscarRegistros(dispatch, params = {}, filtroAvancado = {}) {
  dispatch(setCarregandoRegistros(true));
  try {
    if (filtroAvancado?.pessoa?.endereco?.uf?.nome) {
      filtroAvancado.uf = params?.pessoa?.endereco?.uf?.nome;
      delete filtroAvancado.uf;
    }

    const filtro = {
      ...params,
      ...filtroAvancado,
      uf: filtroAvancado?.pessoa?.endereco?.uf?.nome,
    };

    const response = await transportadoraApi.buscarTransportadoras(filtro);
    dispatch(TransportadoraAction.setCurrentPage(response.data.number));
    dispatch(TransportadoraAction.setPageSize(response.data.size));
    dispatch({ type: BUSCAR_REGISTROS, payload: { page: response.data } });
  } catch (error) {
    dispatch(erro(error.message));
  } finally {
    dispatch(setCarregandoRegistros(false));
  }
}

async function buscarTour(dispatch) {
  dispatch(TransportadoraAction.setCurrentPage(registroTransportadora.number));
  dispatch(TransportadoraAction.setPageSize(registroTransportadora.size));
  dispatch(TransportadoraAction.setSorting(registroTransportadora.sort));
  dispatch({ type: BUSCAR_REGISTROS, payload: { page: registroTransportadora } });
}

async function visualizarRegistro(dispatch, transportadora) {
  dispatch(setCarregandoRegistro(true));
  try {
    const response = await transportadoraApi.buscarTransportadora(transportadora.id);
    dispatch({ type: VISUALIZAR_REGISTRO, payload: response.data });
  } catch (error) {
    dispatch(erro(error.message));
  } finally {
    dispatch(setCarregandoRegistro(false));
  }
}

async function editarRegistro(dispatch, transportadora) {
  dispatch(setCarregandoRegistro(true));
  try {
    const response = await transportadoraApi.buscarTransportadora(transportadora.id);
    dispatch({ type: EDITAR_REGISTRO, payload: response.data });
  } catch (error) {
    dispatch(erro(error.message));
  } finally {
    dispatch(setCarregandoRegistro(false));
  }
}

async function criarRegistro(dispatch, transportadora, params, filtroAvancado) {
  dispatch(setCarregandoRegistro(true));
  try {
    eventReactGA(TRANSPORTADORA, 'Cadastrar transportadora');
    await transportadoraApi.criarTransportadora(transportadora);
    dispatch(sucesso('Transportadora salva com sucesso', { cadastrar: false, visualizar: false }));
    buscarRegistros(dispatch, params, filtroAvancado);
  } catch (error) {
    dispatch(erro(error.response?.data?.message));
  } finally {
    dispatch(setCarregandoRegistro(false));
  }
}

async function atualizarRegistro(dispatch, transportadora, params, filtroAvancado) {
  dispatch(setCarregandoRegistro(true));
  try {
    eventReactGA(TRANSPORTADORA, 'Atualizar transportadora');
    await transportadoraApi.atualizarTransportadora(transportadora.id, transportadora);
    dispatch(sucesso('Transportadora editada com sucesso', { cadastrar: false, visualizar: false }));
    buscarRegistros(dispatch, params, filtroAvancado);
  } catch (error) {
    dispatch(erro(error.response?.data?.message));
  } finally {
    dispatch(setCarregandoRegistro(false));
  }
}

function removerRegistros(dispatch, transportadoras, params) {
  excluirAlert({
    confirmar: async () => {
      dispatch(setCarregandoRegistro(true));
      try {
        eventReactGA(TRANSPORTADORA, 'Excluir transportadora');
        if (params) {
          await transportadoraApi.removerTransportadorasTodosFiltro({
            ids: transportadoras,
            q: params.q,
            tipoSelecao: params.tipoSelecao,
          });
        } else {
          await transportadoraApi.removerTransportadoras(transportadoras);
        }
        dispatch(sucesso('Transportadora excluída com sucesso', { selecionados: [], tipoSelecao: 'NENHUM' }));
        buscarRegistros(dispatch, params);
      } catch (error) {
        dispatch(erro(error.response?.data?.message));
      } finally {
        dispatch(setCarregandoRegistro(false));
      }
    },
  });
}

function setCadastrarRegistro() {
  return {
    type: CADASTRAR_REGISTRO,
  };
}

function setEditarRegistro(payload) {
  return {
    type: EDITAR_REGISTRO,
    payload,
  };
}

function fecharModalCadastro() {
  return {
    type: FECHAR_MODAL_CADASTRO,
  };
}

function fecharModalVisualizacao() {
  return {
    type: FECHAR_MODAL_VISUALIZACAO,
  };
}

function sucesso(message, props = {}) {
  return { type: SUCESSO, payload: { ...props, mensagem: { message, variant: 'success' } } };
}

function erro(message, props = {}) {
  return { type: ERRO, payload: { ...props, mensagem: { message, variant: 'error' } } };
}

const defaultActions = generateDefaultActions(TransportadoraTypes);

export const TransportadoraAction = {
  ...defaultActions,
  setInitialState,
  setSelecionados,
  setTipoSelecao,
  setCarregandoRegistros,
  setCarregandoRegistro,
  setEditarRegistro,
  setCadastrarRegistro,
  setCurrentPage,
  setPageSize,
  setSorting,
  setQuery,
  fecharModal,
  fecharModalCadastro,
  fecharModalVisualizacao,
  buscarRegistros,
  visualizarRegistro,
  criarRegistro,
  atualizarRegistro,
  removerRegistros,
  sucesso,
  erro,
  editarRegistro,
  setFiltroAvancado,
  buscarTour,
};
